import { render, staticRenderFns } from "./InitialTraineeModal.vue?vue&type=template&id=1f396475"
import script from "./InitialTraineeModal.vue?vue&type=script&lang=js"
export * from "./InitialTraineeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports